import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { css, ClassNames } from '@emotion/react';
import { lengths, fonts } from 'decap-cms-ui-default';
import { ParagraphPlugin, Plate, usePlateEditor } from 'platejs/react';
import { SingleBlockPlugin } from 'platejs';
import { editorContainerStyles, EditorControlBar } from '../styles';
import defaultEmptyBlock from './defaultEmptyBlock';
import Toolbar from './components/Toolbar';
import Editor from './components/Editor';
import ParagraphElement from './components/Element/ParagraphElement';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
function editorStyles({
  minimal
}) {
  return /*#__PURE__*/css("position:relative;overflow:hidden;overflow-x:auto;min-height:", minimal ? 'auto' : lengths.richTextEditorMinHeight, ";font-family:", fonts.mono, ";display:flex;flex-direction:column;;label:editorStyles;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}
function RawEditor(props) {
  const {
    className,
    field,
    isShowModeToggle,
    t,
    onChange,
    value
  } = props;
  const initialValue = [defaultEmptyBlock(value || '')];
  const editor = usePlateEditor({
    plugins: [SingleBlockPlugin],
    override: {
      components: {
        [ParagraphPlugin.key]: ParagraphElement
      }
    },
    value: initialValue
  });
  useEffect(() => {
    if (props.pendingFocus) {
      editor.tf.focus({
        edge: 'endEditor'
      });
      props.pendingFocus();
    }
  }, [props.pendingFocus]);
  function handleToggleMode() {
    props.onMode('rich_text');
  }
  function handleChange({
    value
  }) {
    onChange(value.map(line => line.children[0].text).join('\n'));
  }
  return _jsx(Plate, {
    editor: editor,
    value: initialValue,
    initialValue: initialValue,
    onChange: handleChange,
    children: _jsx(ClassNames, {
      children: ({
        cx,
        css
      }) => _jsxs("div", {
        className: cx(className, css`
                ${editorContainerStyles}
              `),
        children: [_jsx(EditorControlBar, {
          children: _jsx(Toolbar, {
            onToggleMode: handleToggleMode,
            buttons: field.get('buttons'),
            disabled: true,
            rawMode: true,
            isShowModeToggle: isShowModeToggle,
            t: t
          })
        }), _jsx("div", {
          css: editorStyles({
            minimal: field.get('minimal')
          }),
          children: _jsx(Editor, {})
        })]
      })
    })
  });
}
RawEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  onMode: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  value: PropTypes.string,
  field: ImmutablePropTypes.map.isRequired,
  isShowModeToggle: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};
export default RawEditor;